exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".custom-h2 {\n    margin-top: 0px !important;\n}\n\n.info-tips-icon {\n    color: grey;\n}\n\n.info-tips-icon:hover {\n    color: #007CBB;\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/config/config.component.css
// module id = 279
// module chunks = 0